import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

@Injectable({ providedIn: 'root' })
export class MarkdownContentService {
  private readonly document = inject(DOCUMENT);

  renderToHtml(markdown: string | null | undefined): string {
    if (!markdown?.trim()) {
      return '';
    }

    const rendered = marked.parse(markdown, {
      async: false,
      breaks: true,
      gfm: true
    }) as string;

    return DOMPurify.sanitize(rendered, {
      USE_PROFILES: { html: true }
    });
  }

  toPlainText(markdown: string | null | undefined, maxLength = 160): string {
    const sanitizedHtml = this.renderToHtml(markdown);
    if (!sanitizedHtml) {
      return '';
    }

    const container = this.document.createElement('div');
    container.innerHTML = sanitizedHtml;

    const plainText = (container.textContent ?? '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!plainText || plainText.length <= maxLength) {
      return plainText;
    }

    return `${plainText.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
  }
}